const {registerModule, KitModule} = window;

class Accordion extends KitModule {
  constructor($element) {
    super($element);

    this.setVars();
    this.bindEvents();
  }

  setVars() {
    this.$details = this.$element.querySelectorAll('.accordion__body--video');
  }

  bindEvents() {
    [...this.$details].forEach(($el) => {
      $el.addEventListener('toggle', this);
    });
  }

  ontoggle(event) {
    const $el = event.currentTarget;

    // if closed, remove the lite-video specific stuff
    // to stop video play and reset
    if (!$el.hasAttribute('open')) {
      const $vid = $el.querySelector('.lite-video');

      if ($vid.classList.contains('is-activated')) {
        $vid.classList.remove('is-activated');

        $vid.querySelector('iframe').remove();
      }
    }
  }
}

registerModule('Accordion', Accordion);
